const networkSignal = function(netType, signal) {
  if (netType === '2') {
    if (signal) {
      switch (signal) {
        case '0':
          return require('@/icon/signal/-s-2G-0.png')
        case '1':
          return require('@/icon/signal/-s-2G-1.png')
        case '2':
          return require('@/icon/signal/-s-2G-2.png')
        case '3':
          return require('@/icon/signal/-s-2G-3.png')
        case '4':
          return require('@/icon/signal/-s-2G-4.png')
        case '5':
          return require('@/icon/signal/-s-2G-4.png')
        default:
          return require('@/icon/signal/-s-2G-4.png')
      }
    }
  } else if (netType === '3') {
    if (signal) {
      switch (signal) {
        case '0':
          return require('@/icon/signal/-s-3G-0.png')
        case '1':
          return require('@/icon/signal/-s-3G-1.png')
        case '2':
          return require('@/icon/signal/-s-3G-2.png')
        case '3':
          return require('@/icon/signal/-s-3G-3.png')
        case '4':
          return require('@/icon/signal/-s-3G-4.png')
        case '5':
          return require('@/icon/signal/-s-3G-4.png')
        default:
          return require('@/icon/signal/-s-3G-4.png')
      }
    }
  } else if (netType === '4') {
    if (signal) {
      switch (signal) {
        case '0':
          return require('@/icon/signal/-s-4G-0.png')
        case '1':
          return require('@/icon/signal/-s-4G-1.png')
        case '2':
          return require('@/icon/signal/-s-4G-2.png')
        case '3':
          return require('@/icon/signal/-s-4G-3.png')
        case '4':
          return require('@/icon/signal/-s-4G-4.png')
        case '5':
          return require('@/icon/signal/-s-4G-4.png')
        default:
          return require('@/icon/signal/-s-4G-4.png')
      }
    }
  } else if (netType === '5') {
    if (signal) {
      switch (signal) {
        case '0':
          return require('@/icon/signal/-s-5G-0.png')
        case '1':
          return require('@/icon/signal/-s-5G-1.png')
        case '2':
          return require('@/icon/signal/-s-5G-2.png')
        case '3':
          return require('@/icon/signal/-s-5G-3.png')
        case '4':
          return require('@/icon/signal/-s-5G-4.png')
        case '5':
          return require('@/icon/signal/-s-5G-4.png')
        default:
          return require('@/icon/signal/-s-5G-4.png')
      }
    }
  } else {
    return require('@/icon/signal/-s-4G-4.png')
  }
}
const videoSignal = function(videoNetType, vidSignal) {
  if (videoNetType === '2') {
    if (vidSignal) {
      switch (vidSignal) {
        case '0':
          return require('@/icon/signal/2G-0.png')
        case '1':
          return require('@/icon/signal/2G-1.png')
        case '2':
          return require('@/icon/signal/2G-2.png')
        case '3':
          return require('@/icon/signal/2G-3.png')
        case '4':
          return require('@/icon/signal/2G-4.png')
        case '5':
          return require('@/icon/signal/2G-4.png')
        default:
          return require('@/icon/signal/2G-4.png')
      }
    }
  } else if (videoNetType === '3') {
    if (vidSignal) {
      switch (vidSignal) {
        case '0':
          return require('@/icon/signal/3G-0.png')
        case '1':
          return require('@/icon/signal/3G-1.png')
        case '2':
          return require('@/icon/signal/3G-2.png')
        case '3':
          return require('@/icon/signal/3G-3.png')
        case '4':
          return require('@/icon/signal/3G-4.png')
        case '5':
          return require('@/icon/signal/3G-4.png')
        default:
          return require('@/icon/signal/3G-4.png')
      }
    }
  } else if (videoNetType === '4') {
    if (vidSignal) {
      switch (vidSignal) {
        case '0':
          return require('@/icon/signal/4G-0.png')
        case '1':
          return require('@/icon/signal/4G-1.png')
        case '2':
          return require('@/icon/signal/4G-2.png')
        case '3':
          return require('@/icon/signal/4G-3.png')
        case '4':
          return require('@/icon/signal/4G-4.png')
        case '5':
          return require('@/icon/signal/4G-4.png')
        default:
          return require('@/icon/signal/4G-4.png')
      }
    }
  } else if (videoNetType === '5') {
    if (vidSignal) {
      switch (vidSignal) {
        case '0':
          return require('@/icon/signal/5G-0.png')
        case '1':
          return require('@/icon/signal/5G-1.png')
        case '2':
          return require('@/icon/signal/5G-2.png')
        case '3':
          return require('@/icon/signal/5G-3.png')
        case '4':
          return require('@/icon/signal/5G-4.png')
        case '5':
          return require('@/icon/signal/5G-4.png')
        default:
          return require('@/icon/signal/5G-4.png')
      }
    }
  } else {
    return require('@/icon/signal/4G-4.png')
  }
}
export { networkSignal,videoSignal }
